/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.addVsmMetric]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('metrics/addVsmMetric', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.setAddVsmMetric, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setAddVsmMetric, err);
        return err.response;
      },
    );
  },
  // [storeActions.addVsmMetric]: ({ commit }, payLoad) => {
  //   console.log(payLoad);
  //   return httpClient.post('metrics/addVsmMetric', payLoad).then(
  //     (res) => {
  //       console.log(res);

  //       commit(storeMutations.setAddVsmMetric, res);
  //       return res;
  //     },
  //     (err) => {
  //       commit(storeMutations.setAddVsmMetric, err);
  //       return err.response;
  //     },
  //   );
  // },
  [storeActions.getVsms]: ({ commit }, payLoad) => {
    let url=`metrics/getVsms?page=${payLoad.page}&limit=${payLoad.limit}`
    // if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    // if(payLoad.search)url+=`&search=${payLoad.search}`
    return httpClient
      .post(
        url,                                                                    
        payLoad,
      ).then(
        (res) => {
          commit(storeMutations.setVsmsMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setVsmsMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getVsmMetric]: ({ commit }, payLoad) => {
    return httpClient.get('/metrics/listVsmMetrics',payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.vsmMetricList, res);
        return res;
      },
      (err) => {
        commit(storeMutations.vsmMetricList, err);
        return err.response;
      },
    );
  },

  [storeActions.updateVsmMetric]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.put('metrics/updateVsmMetric', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.updateVsmMetricStatus]: ({ commit }, payLoad) => {
    console.log(payLoad);
    let url= `metrics/updateVsmMetricStatus?page=${payLoad.page}&limit=${payLoad.limit}`
    return httpClient.put(url, payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };